
module Meevo.Components.AiChat {

    export class MeevoAiChat implements ng.IDirective {
        restrict = "E";
        templateUrl = "app/components/aiChat/aiChat.template.html";
        replace = true;
        controller = "meevo.components.aichat.AiChatController";
        controllerAs = "vm";
        scope = {};
   
        constructor(private $rootScope: ng.IRootScopeService,            
            protected identityService: Meevo.Components.Common.IIdentityService) {
        }
        link = (scope: any, element: JQuery, attr: angular.IAttributes, ctrl: IAiChatController) => {

            scope.isSingleLocation = (): boolean => {
                if (Model.Guard.isSomething(this.identityService.current().isSingleLocation))
                    return this.identityService.current().isSingleLocation;
                else
                    return false;
            }
        }
        static factory(): angular.IDirectiveFactory {
            let directive = ($rootScope, identityService) => {
                return new MeevoAiChat($rootScope,identityService);
            };

            directive.$inject = ["$rootScope", 
                'meevo.components.common.IdentityService'
            ];

            return directive;
        }
}

  angular.module("meevo.components.aichat")
    .directive("meevoAiChat", MeevoAiChat.factory());
}